import { TIMESHEET_HOURS_REGEX } from '../constants';

/**
 * Convert the input value to a floating number of total hours
 * e.g. 8h 30m -> 8.5
 * @param value - The input value
 */
export const hoursToFloat = (value: string) => {
  const match = TIMESHEET_HOURS_REGEX.exec(value);

  if (match) {
    const hoursPart = match[1] ? parseInt(match[1].replace('h', '')) : 0;
    const minutesPart = match[2] ? parseInt(match[2].replace('m', '')) : 0;
    const onlyHours = match[3] ? parseInt(match[3]) : 0;

    // Convert hours and minutes to total hours
    const totalHours = hoursPart + onlyHours + minutesPart / 60;

    // If the total hours is an integer, I have to remove the decimal part. Es. 8h -> 8
    const formattedHours = Number.isInteger(totalHours)
      ? totalHours
      : totalHours.toFixed(2);

    return Number(formattedHours);
  }

  return 0;
};

/**
 * Convert the floating number of total hours to the format HH mm
 * e.g. 8.5 -> 8h 30m
 * @param totalHours - The total hours
 */
export const floatToHours = (totalHours?: number | null) => {
  if (!totalHours) return '';

  const hours = Math.floor(totalHours);
  const minutes = Math.round((totalHours - hours) * 60);

  if (hours && minutes) return `${hours}h ${minutes}m`;
  if (hours) return `${hours}h`;
  if (minutes) return `${minutes}m`;
  return '';
};
